import { Navigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

const RedirectToPolicyDetails = () => {
  const { navigation } = useNavigation()

  const { policy } = useOutletContext<RouteContextParams>()
  const to = navigation.settings.timeoffPolicies.id.details.fullPath({ id: policy?.attributes.id })

  return <Navigate to={to} />
}

export default RedirectToPolicyDetails
